import { render, staticRenderFns } from "./BCXMessengerGroupCollapsible.vue?vue&type=template&id=87bf6a88&scoped=true"
import script from "./BCXMessengerGroupCollapsible.vue?vue&type=script&lang=ts"
export * from "./BCXMessengerGroupCollapsible.vue?vue&type=script&lang=ts"
import style0 from "./BCXMessengerGroupCollapsible.vue?vue&type=style&index=0&id=87bf6a88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87bf6a88",
  null
  
)

export default component.exports